module.exports = __webpack_public_path__ + "static/img/yaxinanna_icon.56bc51a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/yaxinanna_icon.png
// module id = wWHs
// module chunks = 1